<template>
  <div id="page-wrapper" v-if="loggedIn">
    <EplNewBackHeader v-if="$route.query.headerLayout==='enabled'" />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EplNewBackHeader from "@/components/EplNewBackHeader/index";

export default {
  name: "Postpaid",
  components: {
    EplNewBackHeader
  },
  computed: {
    ...mapGetters(["loggedIn"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Postpaid.vue